import React from 'react';

import { useNavigate } from 'react-router-dom';

import {
  Button,
  Typography,
  Icon,
  ScreenWrapper,
  BodyWrapper,
  FooterWrapper,
} from '@liscio/ui';

const HOME_URL = '/dashboard/home';

export const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(HOME_URL, { replace: true });
  };

  return (
    <ScreenWrapper>
      <BodyWrapper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '16px',
        }}
      >
        <Icon icon="lock" sx={{ width: '100px', height: '100px' }} />
        <Typography variant="h2" sx={{ fontSize: '32px' }}>
          You are not authorized to visit this page.
        </Typography>
      </BodyWrapper>
      <FooterWrapper>
        <Button variant="contained" onClick={goBack} fullWidth>
          Go back
        </Button>
      </FooterWrapper>
    </ScreenWrapper>
  );
};

export default AccessDenied;
